import React from "react";
import { GeneralMessage } from "../../common/APICommon";
import { LoadingSpinner } from "../../common/Loading";
import LeaveTypeModule from "../../v2/components/modules/LeaveType/LeaveTypeModule";
import { useLeaveType } from "../../v2/hooks/useLeaveType";
import { useEnumsApi } from "../../v2/hooks/useEnumsApi";

const LeaveTypePageDev = ({ user, userAccess, isHideSideMenu }) => {
  // We initialize the hook ONCE here
  const leaveMethods = useLeaveType();
  const { taxTreatmentsEnum, loading: enumsLoading } = useEnumsApi();


  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Dev Mode > "}</span>
                <span className="border-b border-black">{"Leave Types Dev"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Leave Types (DevMode)</h3>
            </div>

            {/* Pass all hook data and methods to the module */}
            <LeaveTypeModule
              user={user}
              {...leaveMethods}
              taxTreatmentsEnum={taxTreatmentsEnum}
              isAdminMode={true} // DEV MODE FLAG
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={leaveMethods.showMessage}
        message={leaveMethods.message}
        isSuccess={leaveMethods.isSuccess}
      />

      <LoadingSpinner loading={leaveMethods.loading || enumsLoading} />
    </>
  );
};

export default LeaveTypePageDev;